<template>
  <base-tooltip :text="tooltip">
    <button
      class="block px-3 py-2 text-sm text-center focus:outline-none"
      :class="{ [activeClass]: active }"
      v-on="$listeners"
    >
      <span
        class="block w-10 h-10 pt-2 bg-white border group-hover:border-blue-400 rounded-full uppercase leading-normal"
        :class="{ 'border-blue-400': active }"
      >
        <slot />
      </span>
    </button>
  </base-tooltip>
</template>

<script>
export default {
  props: {
    active: Boolean,
    activeClass: String,
    tooltip: String,
  },
};
</script>
